import { useState } from "react";
import { useRouter } from "next/router";
import { connect } from "react-redux";
import Modal from "@components/Modal";
import Button from "@components/Button";
import { removeModal, addModal } from "@store/app/actions";
import { setGTMProductsSortOptions } from "@lib/GTMHelper";

const ResealedSort = ({
  toolbar,
  navigationCategories,
  isModal,
  addModal,
  removeModal,
}) => {
  const [toolbarState, setToolbarState] = useState(toolbar);
  const [selectedSort, setSelectedSort] = useState(null);
  const { push } = useRouter();

  const getSelected = (sort) => {
    const activeUrl = sort.find((option) => option.active)?.url;

    if (activeUrl) {
      return activeUrl;
    }

    const defaultUrl = sort.find((option) => option.default)?.url;

    if (defaultUrl) {
      return defaultUrl;
    }
  };

  const trackSortChange = (url) => {
    const newSortOption = toolbar.sort.find((x) => x.url === url);
    setGTMProductsSortOptions(newSortOption.name);
  };

  if (isModal) {
    return (
      <Modal
        id="toolbar"
        onRemoveModal={() => setToolbarState(toolbar)}
        header="Sorteaza"
      >
        <div className="Toolbar flow-root Toolbar--modal">
          <div className="Form-select">
            <select
              data-test="SORT_SELECT"
              className="!max-w-lg mx-auto block"
              defaultValue={getSelected(toolbar.sort)}
              onChange={(event) => setSelectedSort(event.target.value)}
            >
              {toolbarState.sort.map(({ url, name }) => (
                <option key={url} value={url}>
                  {name}
                </option>
              ))}
            </select>
          </div>

          <div className="mt-6 max-w-lg mx-auto">
            <Button
              onClick={async () => {
                await removeModal();

                if (selectedSort) {
                  trackSortChange(selectedSort);
                  push(selectedSort);
                }
              }}
              variant="primary"
              title="Aplica"
              display="block"
            />
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <div className="Toolbar pb-4 mt-15px">
      <div className="grid grid-flow-row grid-cols-2 grid-rows-2 gap-4 justify-between lg:hidden">
        {navigationCategories && (
          <button
            className="flex col-span-2 justify-center items-center py-2 px-5 border rounded-bl-lg rounded-tr-lg border-primary text-black"
            onClick={() => addModal("resealed")}
          >
            Categorii produse resigilate
          </button>
        )}

        <button
          className="flex justify-center items-center py-2 px-5 border rounded-bl-lg rounded-tr-lg border-primary text-black"
          onClick={() => addModal("filters")}
        >
          <span className="pr-2 flex-none">
            <svg
              width="19"
              height="17"
              viewBox="0 0 19 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 1H0L7.2 9.40889V15.2222L10.8 17V9.40889L18 1V1Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          Filtreaza
        </button>

        <button
          className="flex justify-center items-center py-2 px-5 border rounded-bl-lg rounded-tr-lg border-primary text-black"
          onClick={() => addModal("toolbar")}
        >
          <span className="pr-2 flex-none">
            <svg
              width="21"
              height="17"
              viewBox="0 0 21 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1" fill="white">
                <rect width="21" height="5" rx="1" />
              </mask>
              <rect
                width="21"
                height="5"
                rx="1"
                stroke="black"
                strokeWidth="4"
                mask="url(#path-1-inside-1)"
              />
              <mask id="path-2-inside-2" fill="white">
                <rect y="6" width="17" height="5" rx="1" />
              </mask>
              <rect
                y="6"
                width="17"
                height="5"
                rx="1"
                stroke="black"
                strokeWidth="4"
                mask="url(#path-2-inside-2)"
              />
              <mask id="path-3-inside-3" fill="white">
                <rect y="12" width="13" height="5" rx="1" />
              </mask>
              <rect
                y="12"
                width="13"
                height="5"
                rx="1"
                stroke="black"
                strokeWidth="4"
                mask="url(#path-3-inside-3)"
              />
            </svg>
          </span>
          Sorteaza
        </button>
      </div>

      <div className="hidden lg:inline-flex items-center">
        <div className="Form-select w-[220px]">
          <select
            data-test="SORT_SELECT"
            className="!max-w-lg mx-auto block"
            value={getSelected(toolbar.sort)}
            onChange={async (e) => {
              trackSortChange(e.target.value);
              push(e.target.value);
              window.scrollTo(0, 0);
            }}
          >
            {toolbar.sort.map((option) => (
              <option key={option.url} value={`${option.url}`}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { addModal, removeModal })(ResealedSort);
